function initMap() {
  let contentString = '';

  const setContentString = (item) => `
        <div class="branches-map__item--marker">
          <div class="branches-map__item--marker__icon">
            <img src="/FrontEnd/dist/images/HarborOneIconCropped.png" alt="" />
          </div>
          <div>
            <a href="${item.custom.url}" class="branches-map__item--marker--branch-name">${item.custom.name}</a>
            <address>${item.custom.address}</address>
            ${item.custom.phone ? `<a href="tel:+1${item.custom.phone}">${item.custom.phone}</a>` : ''}
          </div>
        </div>`;

  const onMarkerClick = (marker) => {
    contentString = setContentString(marker);
    window.infoWindow.setContent(contentString);
    window.infoWindow.open(window.mapInstance, marker);
  };

  const deleteMarkers = () => {
    if (window.mapMarkers) {
      for (let i = 0; i < window.mapMarkers.length; i++) {
        window.mapMarkers[i].setMap(null);
      }
    }
    window.mapMarkers = [];
  };

  const setMarkers = () => {
    deleteMarkers();
    const latlngbounds = new window.google.maps.LatLngBounds();

    window.locations.forEach(function (item, index) {
      const myLatLng = new window.google.maps.LatLng(item.lat, item.long);
      latlngbounds.extend(myLatLng);

      /*const icon = `data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2232%22%20height%3D%2245%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20fill%3D%22%232A8436%22%20d%3D%22M16%2044.999S0%2023.541%200%2015.416%205.333%200%2016%200c10.666%200%2016.59%207.152%2016%2015.416-.059%208.056-16%2029.583-16%2029.583Z%22%2F%3E%3Ctext%20text-anchor%3D%22middle%22%20dominant-baseline%3D%22central%22%20font-family%3D%22SourceSansPro,sans-serif%22%20fill%3D%22%23fff%22%20font-size%3D%2216%22%20x%3D%2250%25%22%20y%3D%2240%25%22%3E[hi]%3C%2Ftext%3E%3C%2Fsvg%3E`;*/
      const icon = '/FrontEnd/dist/images/house.png';
      const marker = new window.google.maps.Marker({
        position: myLatLng,
        map: window.mapInstance,
        icon: icon,
        custom: {
          name: item.name,
          address: item.address,
          phone: item.phone,
          url: item.url,
          index: index + 1,
        },
      });

      window.google.maps.event.addListener(marker, 'click', function () {
        onMarkerClick(marker);
      });

      window.mapMarkers.push(marker);
    });

    window.mapInstance.fitBounds(latlngbounds);
  };

  const initialize = () => {
    if (typeof window.locations === 'undefined') return;
    window.mapInstance = new window.google.maps.Map(document.getElementById('map'), {
      zoom: 15,
      maxZoom: 18
    });

    window.infoWindow = new window.google.maps.InfoWindow({
      content: contentString,
      minWidth: 240,
      maxWidth: 330,
    });

    window.google.maps.event.addListener(window.mapInstance, 'click', function () {
      window.infoWindow.close();
    });

    setMarkers();
  };

  if (window.google && window.locations) {
    if (!window.mapInstance) {
      window.google.maps.event.addDomListener(window, 'load', initialize);
    } else {
      setMarkers();
    }
  }
};
initMap();
